
class NavCards {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {

    const navBlockEl = $(".nav-card-block");
    if (!navBlockEl.length) {
      return;
    }

    const card = $(navBlockEl.find(".nav-card"));
    const largeCard = $(navBlockEl).find(".nav-card-large");
    const smalls = $(navBlockEl.find(".nav-card-block__smalls"));
    card.mouseenter(function () {
      card.removeClass("active");
      $(this).addClass("active");
    })

    card.mouseleave(function () {
      card.removeClass("active");
      largeCard.addClass("active");
    })

    smalls.mouseenter(function () {
      $(this).addClass("active");
    })

    smalls.mouseleave(function () {
      $(this).removeClass("active");
    })






  }
}

export default NavCards;
